import { Box, Stack } from '@mui/material';
import News from 'src/features/components/news';
import TextOnPage from 'src/features/components/titlePage';

// ----------------------------------------------------------------------------

export const newsContent = [
  {
    title: 'Acadêmicos de Direito participam de palestra com representantes da OAB',
    course: 'Direito',
    date: '08/05/2025',
    folder: 'palestraOAB',
    lenghtPic: 8,
    color: '#000000',
    ext: 'jpeg'
  },
];

// ----------------------------------------------------------------------------

export default function PalestaOAB() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Stack
        margin={8}
        maxWidth="1140px"
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        alignSelf="center"
      >
        <News content={newsContent}>
          Os acadêmicos de Direito da FASA participaram de palestras no dia 28 de abril com
          representantes da OAB – Subseção de Vilhena:
          <br />
          1ª - OAB Jovem;
          <br />
          2ª OAB - Comissão Prerrogativas
          <br />
          2ª - OAB – Comissão dos Direitos do Consumidor (CDC).
          <br />
          As palestras serviram como atividades complementares, requisitos obrigatórios do curso.
          <br />
          <br />
          Por: Ribamar Araújo (Assessoria/FASA)
        </News>
      </Stack>
    </Box>
  );
}
